import { connect } from 'react-redux';
import { fetchOutreaches } from '../../../redux/Outreach/sagas/outreach/routines';
import {
  clearOutreaches,
  outreachesOnChangePage,
  outreachesOnChangeOrder
} from '../../../redux/Outreach/actions';
import {
  getIsFetching,
  getIsFetched,
  getOrder
} from '../../../redux/Outreach/selectors/outreach';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageItems
} from '../../../redux/Outreach/selectors/outreach/pagination';
import { getSearchQueryForContext } from '../../../redux/Outreach/selectors/components/search';
import paginationAndSearchQuery from '../../../helpers/paginationAndSearchQuery';
import SEARCH_CONTEXT from '../../../helpers/OutreachSearchContext';
import OutreachList from '../../../components/Outreach/OutreachList';
import orderList from '../../../helpers/orderList';

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getSearchQueryForContext(state, SEARCH_CONTEXT.OUTREACH);
  const order = getOrder(state);
  return {
    outreaches: orderList(order, getCurrentPageItems(state)),
    query: { ...paginationAndSearchQuery(paginationQuery, searchQuery), order },
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isFetching: getIsFetching(state),
    isFetched: getIsFetched(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: query => {
      dispatch(fetchOutreaches(query));
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchOutreaches(query));
      else dispatch(outreachesOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(clearOutreaches());
      dispatch(fetchOutreaches(query));
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      dispatch(clearOutreaches());
      dispatch(fetchOutreaches({ ...query, order }));
      dispatch(outreachesOnChangeOrder(order));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OutreachList);
